<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_auth" src="@/assets/images/icon_auth.png" alt=""/>农行授权支付签约</span>
      <el-button class="but2">
        <img class="icon_orderList" src="@/assets/images/icon_orderList.png" alt=""/>
        <span class="sp2">签约历史</span>
      </el-button>

      <el-table :data="tableData" style="width:100%" border :header-cell-style="{'text-align':'center'}">
        <el-table-column align="center" fixed prop="OrderNo" label="签约编号"></el-table-column>
        <el-table-column align="center" fixed prop="SignDate" label="签约时间"></el-table-column>
        <el-table-column align="center" fixed prop="AgentSignStatus" label="签约状态"></el-table-column>
        <el-table-column align="center" fixed prop="Last4CardNo" label="卡号后四位"></el-table-column>
        <el-table-column align="center" fixed label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click.native.prevent="signOff(scope.$index , tableData)"  size="mini" v-if="scope.row.isSign === true">解约</el-button>
            <el-button type="primary" size="mini" v-else>签约失败</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-button class="but2" style="margin-top: 20px">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">填写签约信息</span>
      </el-button>
      <el-form ref="signForm" :model="showInfo" :rules="rules" label-width="100px" class="sign-form">
        <el-form-item class="sp3" label="商户名称:" prop="companyName" style="margin-top: 40px">
          <el-input class="inp" v-model="showInfo.companyName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="客户名称:" prop="customerName">
          <el-input class="inp" v-model="showInfo.customerName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="身份证号:" prop="idCard" style="margin-bottom: 40px">
          <el-input class="inp" v-model="showInfo.idCard"></el-input>
        </el-form-item>
      </el-form>
      <div class="sp3" style="text-align: center">
        <el-button class="but" type="primary" @click="signK(signKInfo , 'signForm')">签约</el-button>
      </div>
      <div class="note"><span style="margin-left: 40px">客户与农行签约授权支付，1个K宝签约1次</span></div>
    </el-main>
  </el-container>
</template>

<script>
import {signUpK, signOffK, signKQuery, signInfoQuery, QuerySignRecord} from "../../../api/system/bank_abc";
import {mapGetters} from "vuex";
import {formatDate, formatTime} from "../../../utils/common";
import {Message} from "element-ui"
import {queryBySale} from "../../../api/system/org-storage";

export default {
  data() {
    return {
      tableData: [],
      showInfo: {
        companyName: '',
        customerName: '',
        idCard: ''
      },
      saleOrgName:'',
      signKInfo: {
        username: '',
        orderNo: '',
        isSign: false,//银行签约成功后更新状态
        signDate: '',
        companyId: '',
        companyName: '',
        idCardNo: '',
        customerId: '',
        customerName: ''
      },
      rules: {
        companyName: [
          {required: true, message: '请输入授权支付签约商户名称', trigger: 'blur'}
        ],
        customerName: [
          {required: true, message: '请输入客户名称', trigger: 'blur'}
        ],
        idCard: [
          {required: true, message: '请输入客户身份证号', trigger: 'blur'},
          {min:15 , max:18 , message: '身份证号格式不正确'}
        ]
      },
      timeLineHeight: ""
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["saleOrgs"]),
    ...mapGetters(["sIndex"])
  },
  mounted() {
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    this.timeLineHeight = document.documentElement.clientHeight - 50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    this.refresh();
  },
  methods: {
    refresh() {
      this.tableData = [];
      let signParam = {};
      signParam.username = this.currentUser.username;
      signParam.isDeleted = 0
      //仅展示签约成功的数据
      signParam.isSign = 1
      let _this = this;
      QuerySignRecord(signParam).then(res => {
        console.log(res)
        for (let signRecord of res.data.records) {
          //获取银行签约详情
          let abcSignQueryParam = {};
          abcSignQueryParam.orderNo = signRecord.orderNo;
          let tableDataItem = {};
          tableDataItem.OrderNo = signRecord.orderNo;
          tableDataItem.SignDate = signRecord.signDate;
          tableDataItem.AgentSignStatus = (signRecord.isSign === true ? '已签约' : '未签约')
          tableDataItem.Last4CardNo = signRecord.cardLast4Number;
          tableDataItem.isSign = signRecord.isSign;
          _this.tableData.push(tableDataItem);
        }
      }).catch(error =>{
        Message.error("获取签约记录失败！")
      });

      _this = this;
      signInfoQuery({}).then(res => {
        //console.log(res)
        _this.showInfo.companyName = res.data.merchantName;
        _this.showInfo.customerName = _this.currentUser.customer.name;

        //init signKInfo
        _this.signKInfo.username = _this.currentUser.customer.number;
        _this.signKInfo.orderNo = res.data.bankFlowId;
        //debugger;
        let time = formatTime(new Date().toISOString());
        let milliSecodeIndex = time.lastIndexOf('.');
        _this.signKInfo.signDate = formatDate(new Date().toISOString()) + ' ' + time.substring(0 , milliSecodeIndex);

        _this.signKInfo.idCardNo = _this.showInfo.idCard;
        _this.signKInfo.customerId = _this.currentUser.customer.id;
        _this.signKInfo.customerName = _this.currentUser.customer.name;
      }).catch(error => {
        Message.error("商户签约信息获取失败！")
      });

      _this = this;
      let param = {}

      param.id = this.saleOrgId;
      //获取发货公司+付款公司
      queryBySale(param).then(res => {
        if(res.code === 200){
          _this.orgInfos = res.data;
          if(_this.isNull(_this.orgInfos , "无法获取当前销售组织委托的库存组织与财务组织！")){
            return;
          }
          _this.signKInfo.companyId = _this.orgInfos[0].id;
          _this.signKInfo.companyName = _this.orgInfos[0].name;
        }
      })
    },
    signK(signKInfo, formName) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.signKInfo.idCardNo = _this.showInfo.idCard;
          signUpK(signKInfo).then(res => {
            Message.info("请在弹出页面完成签约！");
            _this.refresh();
            //签约跳转地址
            window.open(res.data,'_blank');
          }).catch(error=>{
            Message.error("签约失败！")
          })
        } else {
          Message.warning("缺少必填信息！");
        }
      })
    },
    signOff(index, tableData) {
      this.$confirm('确定解约么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {}
        param.orderNo = tableData[index].OrderNo;
        param.customerId = this.currentUser.customer.id
        param.agentSignNo = tableData[index].OrderNo;
        param.requestDate = formatDate(new Date().toISOString());
        param.requestTime = formatTime(new Date().toISOString());
        signOffK(param).then(res => {
          if (res.code === 200) {
            Message.info("解约成功！");
            this.refresh();
          } else {
            Message.info("解约失败，请重试！");
          }
        }).catch(error => {
          Message.error("解约失败！")
        })
      }).catch(() => {
        console.log("取消解约")
      });
    },
    isNull(array , msg){
      if(array === null || array.length <= 0){
        this.$message({
          message:msg,
          type:'error'
        })
        return true;
      }
      return false;
    },
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
  }
}
</script>

<style scoped>
  .sign-form {
    /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
    border:1px solid #EBEEF5;
    /*margin-top: 20px;*/
    /*margin: 20px;*/
    /*padding: 20px;*/
  }
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .icon_auth{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .sp3{
    margin-left: 70px;
  }
  .icon_orderList{
    /* 减去顶层 */
    position: absolute;
    width: 14px;
    height: 16px;
  }
  .but{
    margin-left: -160px;
    margin-top: 30px;
    width: 120px;
    font-size: 16px;
    color: white;
    border: none;
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
    border-radius: 20px;
  }
  .inp{
    width: 300px;
  }
  .note{
    margin-top: 60px;
    height: 60px;
    background: #f5f7fa;
    color: #ff5000;
    line-height: 60px;
  }
</style>
